var _circle, _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#292374"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#5985CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9717 71.0104C26.5705 63.1768 29.6453 54.8616 37.4222 53.1738C39.5672 52.7083 41.9674 52.4078 44.5896 52.4078C47.1626 52.4078 49.5597 52.6971 51.7329 53.1478C59.9029 54.8419 63.3225 63.5196 61.8534 71.733L58.5418 90.2462H31.4125L27.9717 71.0104Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4557 63.2973C54.8584 60.9447 53.6303 58.7809 52.9946 56.4384C52.6279 55.0872 52.7696 53.8355 54.5535 53.8355C55.2435 53.8355 56.1142 54.0227 57.0795 54.3306C64.3141 56.6377 68.0093 64.3677 68.0093 71.9613V90.246H62.298L55.4557 63.2973Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3998 63.2973C35.9971 60.9447 37.2252 58.7809 37.8609 56.4384C38.2276 55.0872 38.0859 53.8355 36.302 53.8355C35.612 53.8355 34.7413 54.0227 33.776 54.3306C26.5414 56.6377 22.8462 64.3677 22.8462 71.9613V90.246H28.5575L35.3998 63.2973Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.9998,
    cy: 32.8378,
    r: 15.8108,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 44.9771,
    y1: 76.5,
    x2: 44.9771,
    y2: 133.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 67.1096,
    y1: 68.1141,
    x2: 59.2564,
    y2: 68.1141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 23.7459,
    y1: 68.1141,
    x2: 31.5991,
    y2: 68.1141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotAvatar);
export default __webpack_public_path__ + "static/media/botAvatar.f4abf55e17b2f399cf3af046a7a58f04.svg";
export { ForwardRef as ReactComponent };